import { Injectable } from '@angular/core';
import * as Forge from 'node-forge';

@Injectable({
  providedIn: 'root',
})
export class RSAHelper {
  publicKey: string = `-----BEGIN PUBLIC KEY-----
  MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQC3jVr8ROufTpsb7NhUpnzRTFgb
  zOB0/29xg4U2ZVESIWIZF5rn7mJvg4PXGteqZQ6GUtkiBXwncdWthrUT8NS4qHO0
  PkV4JG+9YIzwzw9CLiG/jQZUEi1mOE3R0G/Gd8NtieN07N/34fKgThYQNVH7+k1Y
  3K9eNstdz8UzK2im6QIDAQAB
  -----END PUBLIC KEY-----`;

  constructor() {}

  encryptWithPublicKey(valueToEncrypt: string): string {
    const rsa = Forge.pki.publicKeyFromPem(this.publicKey);
    return window.btoa(rsa.encrypt(valueToEncrypt.toString()));
  }
}
